import SickIcon from "@mui/icons-material/Sick";
import { SICK_LEAVES_LIST, EmployeeServicePath } from "utils/constants";
import ListSickLeaves from "./List";

export const resources = {
  isMenu: true,
  icon: <SickIcon />,
  name: `${EmployeeServicePath}${SICK_LEAVES_LIST}`,
  title: "Болнични",
  list: <ListSickLeaves />,
};
